// Display-only cleaning of content titles for the Study Planner views.
// Strips the leading "topic + number" prefix (e.g. "ANGIOLOGIA 1.", "CIRUGIA GENERAL 5.",
// "Repaso 2.") so the admin can reorder freely without confusing out-of-sequence numbers.
// Does NOT modify stored data.
export const cleanPlannerTitle = (title) => {
  if (!title) return title;
  let t = String(title).trim();
  // 1) Leading "Repaso N." (mixed case)
  t = t.replace(/^\s*repaso\s*\d+\s*[.\-:]?\s*/i, '');
  // 2) Leading UPPERCASE topic words + number, e.g. "ANGIOLOGIA 1.", "TRAUMATOLOGIA Y ORTOPEDIA 3."
  t = t.replace(/^\s*[A-ZÁÉÍÓÚÜÑ][A-ZÁÉÍÓÚÜÑ\s]*?\d+\s*[.\-:]?\s*/, '');
  return t.trim() || title;
};
